@let target = target$ | async;
@if (target) {
  @if (feedbackType === 'shape') {
    @if (target === 'list') {
      <h3-shape-feedback-list />
    }
    @if (target === 'upsert') {
      <h3-add-edit-feedback-dialog />
    }
  }
  @if (feedbackType === 'client') {
    @if (target === 'list') {
      <h3-client-issue-list />
    }
    @if (target === 'upsert') {
      <h3-add-edit-client-issue-dialog />
    }
    @if (target === 'view') {
      <h3-client-issue-detail-view />
    }
  }
}
